/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Component, Input } from '@angular/core';

/**
 * @description
 *
 * Este componente agrupa os componentes de layout da aplicação em um formato fixo e padronizado.
 *
 */
@Component({
  selector: 'unesp-core-layout',
  templateUrl: './unesp-core-layout.component.html',
  styleUrls: ['./unesp-core-layout.component.css'],
})
export class UnespCoreLayoutComponent {
  /**
   * @description
   *
   * Nome completo da aplicação a ser exibido em telas maiores.
   *
   */
  @Input() fullTitle!: string;

  /**
   * @description
   *
   * Nome abreviado da aplicação a ser exibido em telas menores.
   *
   */
  @Input() shortTitle!: string;

  /**
   * @description
   *
   * Texto que irá aparecer no rodapé.
   *
   */
  @Input() footerText!: string;


   /**
   * @description
   *
   * Logo customizado header
   *
   */
    @Input() logoCustom!: string;

    /**
   * @description
   *
   * Spinner personalizado
   *
   */
     @Input() spinnerCustom!: string;
}
